// React
import React from 'react'
import PropTypes from 'prop-types'

// Components
import Button from './Button'
import ButtonNext from './ButtonNext'

// Shared
import registerCustomElement from 'shop-components/utils/registerCustomElement'

const DatePicker = ({ version }) => {
  return version === 'next' ? <ButtonNext /> : <Button />
}

DatePicker.propTypes = {
  version: PropTypes.string
}

registerCustomElement('bq-date-picker', DatePicker, {
  attributes: ['version']
})
